import { IUserSettings } from 'api/api';
import actionCreatorFactory from 'typescript-fsa';
import { constants } from './constants';

const actionCreator = actionCreatorFactory("userSettings");

export const getUserSettingsAction = actionCreator.async<{}, IUserSettings>(constants.GET_USERSETTINGS);
export const upsertUserSettingsAction = actionCreator.async<IUserSettings, IUserSettings >(constants.UPSERT_USERSETTINGS);
